/**
 * AggregateTile — "value / label" cell used in the YTD aggregate strip.
 * Takes pre-formatted strings so primitives stay i18n-agnostic.
 */

export interface AggregateTileOptions {
  readonly value: string;
  readonly label: string;
}

export function renderAggregateTile(opts: AggregateTileOptions): HTMLElement {
  const tile = document.createElement('div');
  tile.className = 'ag-agg-tile';
  const v = document.createElement('div');
  v.className = 'ag-agg-tile__value';
  v.textContent = opts.value;
  const l = document.createElement('div');
  l.className = 'ag-agg-tile__label';
  l.textContent = opts.label;
  tile.appendChild(v);
  tile.appendChild(l);
  return tile;
}
